import { createContext, PropsWithChildren, useReducer } from 'react';

interface StepsContextType {
	step: number;
	hasBackStep: boolean;
	hasNextStep: boolean;
	isLastStep: boolean;
	nextStepEnabled: boolean;
	updateSteps?: any;
}

const defaultStepContext: StepsContextType = {
	step: 1,
	hasBackStep: false,
	hasNextStep: true,
	isLastStep: false,
	nextStepEnabled: true,
};

type NewStepType = 'next' | 'back' | number | undefined;

type ReducerType = (state: StepsContextType, value: { step?: NewStepType; nextStepEnabled?: boolean }) => any;

export const StepsContext = createContext(defaultStepContext);

const totalSteps = 2;

function reducer(
	stepStorage: StepsContextType,
	payload: {
		step?: NewStepType;
		nextStepEnabled?: boolean;
	}
) {
	let newStep = stepStorage.step;

	if (payload.step) {
		switch (payload.step) {
			case 'next':
				newStep = stepStorage.step + 1 <= totalSteps ? stepStorage.step + 1 : stepStorage.step;
				break;
			case 'back':
				newStep = stepStorage.step - 1 > 0 ? stepStorage.step - 1 : stepStorage.step;
				break;
			default:
				newStep = payload.step;
				break;
		}
	}

	return {
		step: newStep,
		hasBackStep: newStep > 1,
		hasNextStep: newStep + 1 <= totalSteps,
		isLastStep: newStep + 1 > totalSteps,
		nextStepEnabled: payload.nextStepEnabled,
	};
}

export const StepsProvider = (props: PropsWithChildren<{}>) => {
	const [stepStorage, updateSteps] = useReducer<ReducerType>(reducer, defaultStepContext);

	return <StepsContext.Provider value={{ ...stepStorage, updateSteps }}>{props.children}</StepsContext.Provider>;
};
